import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { cn } from '../../lib/utils';

const WhyUs = () => {
  const navigate = useNavigate();

  const handleLearnMore = () => {
    navigate('/about');
  };

  return (
    <section className="py-16 md:py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <motion.div 
            className="bg-gradient-to-br from-gray-800 to-gray-700 rounded-2xl overflow-hidden shadow-xl"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 0.4 }}
          >
            <div className="grid lg:grid-cols-2 gap-0">
              <motion.div
                className="p-6 lg:p-8"
                initial={{ opacity: 0, x: -20 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.6, delay: 0.2 }}
              >
                <motion.h2 
                  className="text-4xl lg:text-5xl font-display font-semibold text-white mb-6"
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6, delay: 0.1 }}
                >
                  Who We Are
                </motion.h2>
                <p className="text-base lg:text-lg text-gray-300 mb-6">
                  Solutions21 is the brainchild of Expo City Dubai, built on a decade of experience 
                  delivering technology for global mega-events. We create innovative, scalable, and 
                  high-impact digital solutions that drive business transformation.
                </p>
                <motion.button
                  onClick={handleLearnMore}
                  className="group inline-flex items-center text-accent font-medium hover:text-accent/80 transition-colors duration-300"
                >
                  Learn More About Us
                  <ArrowRight className="w-4 h-4 ml-2 transform group-hover:translate-x-1 transition-transform duration-300" />
                </motion.button>
              </motion.div>

              <motion.div
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                transition={{ duration: 0.6 }}
                className="relative h-full min-h-[300px]"
              >
                <img
                  src="https://images.ctfassets.net/r2cfrvo3y08m/3P04vhO3MtTxgG2CCZFs7j/903f5254b19932b1b234e07ff9b32258/240821_ECD_39_DMP_Visual_Aerial_UNStudio-update.jpg?w=2880"
                  alt="Technology infrastructure"
                  className="absolute inset-0 w-full h-full object-cover"
                />
              </motion.div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default WhyUs;